<mat-card class="cardWithShadow theme-card">
    <mat-card-header>
        <mat-card-title>Detalle de Operacion N°{{ data.invoiceOperationId }}</mat-card-title>
        <button mat-icon-button (click)="closeDialog()" style="position: absolute; right: 10px">
            <mat-icon>close</mat-icon>
        </button>
        <!--<hr class="linea-separadora">-->
    </mat-card-header>

    <mat-divider style="margin-top: 20px;"></mat-divider>

    <mat-card-content class="spinner" *ngIf="!datosCargados">
        <mat-spinner diameter="70"></mat-spinner>
    </mat-card-content>

    <mat-card-content *ngIf="datosCargados">

        <div class="row">
            <div class="col-md-6"> 
              <table>
                <tr>
                    <td><h4>Folio Asociado:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="detailOperations">{{ this.data.folio}}</h4>
                        <h4 class="detalle" *ngIf="!detailOperations">No hay Informacion</h4>
                    </td>
                </tr>
                <tr>
                    <td><h4>Monto Financiado:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="detailOperations">{{ this.detailOperations.financedAmount | currency:'CLP':'symbol' }}</h4>
                        <h4 class="detalle" *ngIf="!detailOperations">No hay Informacion</h4>
                    </td>
                </tr>
                <tr>
                    <td><h4>Costo Operacional:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="detailOperations">{{ this.detailOperations.operationalCost | currency:'CLP':'symbol' }}</h4>
                        <h4 class="detalle" *ngIf="!detailOperations">No hay Informacion</h4>
                    </td>
                </tr>
                <tr>
                    <td><h4>Monto Transferencia:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="detailOperations">{{ this.detailOperations.transferAmount | currency:'CLP':'symbol' }}</h4>
                        <h4 class="detalle" *ngIf="!detailOperations">No hay Informacion</h4>
                    </td>
                </tr>
                <tr>
                    <td><h4>Plazo:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="detailOperations">{{ this.data.plazo + ' Dias' }}</h4>
                        <h4 class="detalle" *ngIf="!detailOperations">No hay Informacion</h4>
                    </td>
                </tr>
              </table>
            </div>
            <div class="col-md-6"> 
                <table>
                    <tr>
                        <td><h4>Taza:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="detailOperations">{{ this.data.rate + '%' }}</h4>
                            <h4 class="detalle" *ngIf="!detailOperations">No hay Informacion</h4>
                        </td>
                    </tr>
                    <tr>
                        <td><h4>Creado:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="detailOperations">{{ this.detailOperations.createdAt | date : "dd/MM/yyyy" }}</h4>
                            <h4 class="detalle" *ngIf="!detailOperations">No hay Informacion</h4>
                        </td>
                    </tr>
                    <tr>
                        <td><h4>Fecha Actulizacion:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="detailOperations">{{ this.data.lastUpdate | date : "dd/MM/yyyy" }}</h4>
                            <h4 class="detalle" *ngIf="!detailOperations">No Actualizada</h4>
                        </td>
                    </tr>
                    <tr>
                        <td><h4>Ejecutivo:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="detailOperations">{{ this.data.executiveName }}</h4>
                            <h4 class="detalle" *ngIf="!detailOperations">Sin Ejecutivo Designado</h4>
                        </td>
                    </tr>
                    <tr>
                        <td><h4>Comentario:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="detailOperations">{{ this.detailOperations.comments }}</h4>
                            <h4 class="detalle" *ngIf="!detailOperations">No Se Incluyo un Comentario</h4>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

    </mat-card-content>
</mat-card>